export enum StatusEnum {
  Active = 1,
  Pending = 2,
  Deleted = 3,
  Paused = 4,
  Ended = 5
}
